import { thunkProgress } from 'redux-progress';

import type { Dispatch, GetState } from 'model/State';
import { currencyList } from 'modules/mac/duck/api';
import { CURRENCY_LIST } from './types';

export const fetchCurrencyList = () => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();

  const currencyListData = currencyList(state);
  dispatch(thunkProgress(CURRENCY_LIST, currencyListData));
};
